// src/pages/transactions/New.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import { parseNum, getTodayJalali } from '../../utils/factorHelpers';
import TransactionForm, { NO_CUSTOMER_METHODS } from './TransactionForm';
const New = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [form, setForm] = useState({
    direction: 'receive',
    method: 'card',
    date: getTodayJalali(),
    amount: '',
    trackingNo: '',
    chequeSerial: '',
    charityName: '',
    description: '',
    bankId: '',
  });

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const isDirtyRef = useRef(false);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  useEffect(() => {
    const handler = (e) => {
      if (!isDirtyRef.current) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);

  const markDirty = () => {
    isDirtyRef.current = true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const noCustomer = NO_CUSTOMER_METHODS.includes(form.method);

if (!noCustomer && !customer?.id) {
  setMessage('لطفاً یک مشتری انتخاب کنید');
  setMessageType('danger');
  return;
}
    setSaving(true);
    try {
      await api.post('/transactions', {
        direction: form.direction,
        method: form.method,
        date: form.date || getTodayJalali(),
        amount: parseNum(form.amount),
        customerId: noCustomer ? null : customer.id,
        trackingNo: form.trackingNo,
        chequeSerial: form.chequeSerial,
        charityName: form.charityName,
        description: form.description,
        customerId: noCustomer ? null : customer.id,
                bankId: form.bankId || null,
      });

      isDirtyRef.current = false;
      setMessage('تراکنش با موفقیت ثبت شد');
      setMessageType('success');
      setTimeout(() => navigate('/dashboard/transactions'), 800);
    } catch (err) {
      setMessage(err.response?.data?.error || 'خطا در ثبت تراکنش');
      setMessageType('danger');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {message && (
        <div className={messageType === 'danger' ? 'toast-danger' : 'toast-success'}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <TransactionForm
          form={form}
          setForm={setForm}
          customer={customer}
          setCustomer={setCustomer}
          onDirty={markDirty}
        />

        <div className="flexend">
          <Link className="btn secondary" to="/dashboard/transactions">
            <i className="fa-solid fa-xmark" /> انصراف
          </Link>
          <button className="btn" type="submit" disabled={saving}>
            {!saving && <i className="fa-solid fa-floppy-disk" />}
            {saving ? 'در حال ذخیره...' : 'ثبت تراکنش'}
          </button>
        </div>
      </form>
    </>
  );
};

export default New;
